import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-hidden"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_4 = {
  class: "min-w-0"
};
const _hoisted_5 = {
  class: "truncate text-lg font-semibold text-slate-900"
};
const _hoisted_6 = {
  key: 0,
  class: "mt-1 truncate text-sm text-slate-500"
};
const _hoisted_7 = {
  class: "min-h-0 flex-1 overflow-y-auto p-6"
};
const _hoisted_8 = {
  key: 0,
  class: "border-t border-slate-200 px-6 py-4"
};
import { ref, toRef } from 'vue';
import { useModalA11y } from '@/composables/useModalA11y';
export default {
  __name: 'WealthDetailDrawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '详情'
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const panelRef = ref(null);
    useModalA11y(toRef(props, 'modelValue'), panelRef, () => emit('update:modelValue', false));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/40",
        onClick: _cache[0] || (_cache[0] = $event => emit('update:modelValue', false))
      }), _createElementVNode("section", {
        ref_key: "panelRef",
        ref: panelRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": __props.title,
        tabindex: "-1",
        class: "absolute right-0 top-0 flex h-full w-full max-w-5xl flex-col bg-white shadow-xl"
      }, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString(__props.title), 1), __props.subtitle ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.subtitle), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
        type: "button",
        class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
        onClick: _cache[1] || (_cache[1] = $event => emit('update:modelValue', false))
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("main", _hoisted_7, [_renderSlot(_ctx.$slots, "default")]), _ctx.$slots.footer ? (_openBlock(), _createElementBlock("footer", _hoisted_8, [_renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("", true)], 8, _hoisted_2)])) : _createCommentVNode("", true)]);
    };
  }
};